// Import HTTP methods utility
import { httpGet } from "../../utils/httpMethods";
import { REFERRAL_URL } from "../restEndpoint";

// Get referral discount by user ID
export const getReferralById = async (userId) => {
  return await httpGet({ url: `${REFERRAL_URL}/getReferralById/${userId}` })
    .then((res) => {
      (res, "get referral by user id");
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};